import React, { useState, useEffect } from 'react'

import { ChevronLeftIcon } from '@primer/octicons-react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import axios from 'axios'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import ListGroup from 'react-bootstrap/ListGroup'
import ListGroupItem from 'react-bootstrap/ListGroupItem'
import Swal from 'sweetalert2'

import { seo } from '../../components/seo.component'
import authHeader from '../../services/auth-header'
import useIsCoach from '../../components/lib/auth/useIsCoach'
import CodeEditor from '../../components/code-editor.component'
import MarkdownDisplay from '../../components/markdown/markdown-display.component'
import StringService from '../../services/string-service'

import { BASENAME, REST_API } from './../../services/constants'
import './training-page.scss'
import TaskFileList from './TaskFileList'

export default function TrainingPage() {

    let { id, task } = useParams();
    let history = useHistory();
    let location = useLocation();

    const isCoach = useIsCoach();

    const [ topic, setTopic ] = useState(null);
    const [ tasks, setTasks ] = useState([]);
    const [ focusedTaskIndex, setFocusedTaskIndex ] = useState(0);
    const [ focusedTaskState, setFocusedTaskState ] = useState(null);
    const [ resolutions, setResolutions ] = useState([]);

    const updateTopic = async () => {
        axios({
            method: "GET",
            url: `${REST_API}/api/secure/topics/${id}`,
            headers: await authHeader()
        }).then(response => {
            if (response.status === 200) {
                setTopic(response.data);
            }
        });
    }

    const updateTopicTaks = async () => {
        axios({
            method: "GET",
            url: `${REST_API}/api/secure/tasks/topic/${id}`,
            headers: await authHeader()
        }).then(response => {
            if (response.status === 200) {
                const sortedTasks = [...response.data].sort((a, b) => a.name.localeCompare(b.name));
                setTasks(sortedTasks);
            }
        });
    }

    const loadResolutions = async () => {
        axios({
            method: "GET",
            url: `${REST_API}/api/secure/topics/${id}/resolutions/`,
            headers: await authHeader()
        }).then(response => {
            if (response.status === 200) {
                setResolutions(response.data);
            }
        });
    }

    const updateResolutionForTask = async (targetTaskId, newState, updateFocused) => {
        axios({
            method: "POST",
            url: `${REST_API}/api/secure/topics/resolutions/`,
            headers: await authHeader(),
            data: {
                taskId: targetTaskId,
                finished: newState
            }
        }).then(response => {
            if (response.status === 200) {
                if (updateFocused === true) {
                    setFocusedTaskState(newState);
                }

                loadResolutions();

                if (newState === true) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Als erledigt markiert'
                    });
                } else if (newState === false) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Als ausstehend markiert'
                    });
                }
            } else {
                Toast.fire({
                    icon: 'warning',
                    title: 'Speicherung nicht bestätigt'
                });
            }
        }).catch(err => {
            Toast.fire({
                icon: 'error',
                title: 'Verbindung fehlgeschlagen'
            });
        });
    }

    const updateCodeForResolution = async (targetTaskId, newCode) => {
        axios({
            method: "POST",
            url: `${REST_API}/api/secure/topics/resolutions/`,
            headers: await authHeader(),
            data: {
                taskId: targetTaskId,
                code: newCode
            }
        }).then(response => {
            if (response.status === 200) {

            } else {

            }
        });
    }

    const calculateFocusedResolution = (index) => {
        if (!tasks) {
            console.log("Aborted calculation of focsued resolution. Reason: Tasks are empty.");
            return;
        }

        if (!tasks[index]) {
            console.log("Aborted calculation of focused resolution. Reason: Referenced index of tasks is empty. Tasks size: " + (tasks ? tasks.length : "undefined") + " Requested Index: " + index);
            return;
        }

        let taskId = tasks[index].id;
        console.log("Changing focus on task " + taskId);

        let focusedResolution = resolutions.find(x => x.taskId == taskId);
        console.log("Changing focus on task resolution: (" + (focusedResolution ? focusedResolution.finished : "null") + ")");

        setFocusedTaskState(focusedResolution ? focusedResolution.finished : false);
    }

    const setFocusedTaskIndexWithPreLogic = (index) => {
        history.push(`/training/topic/${id}/${index}`);
        calculateFocusedResolution(index);
        setFocusedTaskIndex(index);
    }

    useEffect(() => {
        updateTopic();
        updateTopicTaks();
        loadResolutions();

        if (task) {
            console.log("Dedected task identifier in link: " + task);
            if (StringService.isNumeric(task)) {
                setFocusedTaskIndex(parseInt(task));
            } else {
                console.log("Identifier seems to be an invalid number (not of type int).");
            }
        }
    }, [])

    // Do something after tasks changed
    useEffect(() => {
        calculateFocusedResolution(focusedTaskIndex);
    }, [tasks])

    useEffect(() => {
        if (topic === null || topic === undefined) {
            seo({
                title: 'Ungültiger Link'
            });
            return;
        }

        const targetTask = tasks[focusedTaskIndex];

        if (targetTask === null || targetTask === undefined) {
            seo({
                title: `${topic.title} » Lade Aufgaben...`
            });
            return;
        }

        seo({
            title: `${topic.title} » ${targetTask.name}`
        });
    }, [topic, tasks, focusedTaskIndex]);

    return (
        <>
            <div className="d-flex">
                <div className="d-flex align-items-center">
                    <a href={"#" + BASENAME + "account/dashboard"} className="btn btn-primary mr-4">
                        <ChevronLeftIcon size={24} />
                        Zurück
                    </a>
                    <h2 className="mb-0">{topic?.title ?? 'Unbekanntes Thema'}</h2>
                </div>

                {
                    tasks && tasks.length > 0 &&
                    <div className="ml-auto">
                        {
                            isCoach &&
                            <a href={"#" + BASENAME + "admin-dashboard/topics/" + topic?.id + "/tasks/" + tasks[focusedTaskIndex].id + "?referrer=" + location.pathname} className="btn btn-primary">Bearbeiten</a>
                        }
                    </div>
                }
            </div>

            <div className={"training-page mt-4 " + (topic && topic.info ? null : "training-page-light")}>
                <Card>
                    <Card.Header>Aufgaben</Card.Header>
                    {
                        !tasks ?
                        <p className="p-2 text-muted">Laden...</p> :
                        tasks.length === 0 ?
                        <p className="p-2 text-muted">Keine Fragen</p>
                        :
                        <>
                            <ListGroup className="list-group-flush list-group-tasks">
                                {
                                    tasks.map((item, index) => {
                                        { var finished = resolutions.some(x => x.taskId == item.id) ? resolutions.find(x => x.taskId == item.id).finished : false }
                                        return <ListGroupItem key={index} className={focusedTaskIndex === index && 'list-group-item-active'}>
                                            <Form.Check
                                                type="checkbox"
                                                className="my-1 mr-sm-2 custom-checkbox-inline"
                                                id={`task_id_${index}`}
                                                aria-label={`Status Aufgabe ${index+1}`}
                                                custom
                                                defaultChecked={false}
                                                checked={finished}
                                                onChange={() => updateResolutionForTask(item.id, !finished, item.id === tasks[focusedTaskIndex].id)} />
                                            <a href="javascript:void(0);" role="link" title={`Link zu Aufgabe ${index+1}`} aria-label={`Link zu Aufgabe ${index+1}`} onClick={() => setFocusedTaskIndexWithPreLogic(index)}>{item.name}</a>
                                        </ListGroupItem>
                                    })
                                }
                            </ListGroup>
                        </>
                    }
                </Card>
                <Card tabIndex="0">
                    {
                        !tasks || tasks.length === 0 ?
                        <>
                        <Card.Header>Keine Aufgabe ausgewählt</Card.Header>
                        <Card.Body>
                            <p className="text-center">Keine Daten verfügbar</p>
                        </Card.Body>
                        </>
                        :

                        focusedTaskIndex >= 0 && focusedTaskIndex < tasks.length ?

                        <>
                        <Card.Header>
                            <span className="mr-3">Aufgabe {focusedTaskIndex + 1} / {tasks.length}</span>
                            <Form.Check
                                type="checkbox"
                                className="my-1 mr-sm-2 custom-checkbox-inline"
                                label="Erledigt"
                                id="current_task_finished"
                                custom
                                defaultChecked={false}
                                checked={focusedTaskState}
                                style={{fontWeight: 600, float: 'right'}}
                                onChange={() => updateResolutionForTask(tasks[focusedTaskIndex].id, !focusedTaskState, true)} />
                        </Card.Header>
                        <Card.Body>
                            <Card.Title>{tasks[focusedTaskIndex].name}</Card.Title>
                            <MarkdownDisplay content={tasks[focusedTaskIndex].content} />

                            {
                                tasks[focusedTaskIndex]?.expectsCodeSubmission ?
                                    <CodeEditor code={resolutions.find(x => x.taskId === tasks[focusedTaskIndex].id)?.code} onChange={(x) => updateCodeForResolution(tasks[focusedTaskIndex].id, x) } />
                                : null
                            }

                            <TaskFileList taskId={tasks[focusedTaskIndex].id} />
                        </Card.Body>
                        <Card.Footer>
                            <Form.Check
                                type="checkbox"
                                className="my-1 mr-sm-2 custom-checkbox-inline"
                                label="Erledigt"
                                id="current_task_finished_2"
                                custom
                                defaultChecked={false}
                                checked={focusedTaskState}
                                style={{fontWeight: 600, width: "100%", textAlign: "right"}}
                                onChange={() => updateResolutionForTask(tasks[focusedTaskIndex].id, !focusedTaskState, true)} />
                        </Card.Footer>
                        </>

                        :

                        <>
                        <Card.Header>Keine Aufgabe ausgewählt</Card.Header>
                        <Card.Body>
                            <h5>Invalider Link</h5>
                            <p>Es scheint so als hätte da jemand gemorgelt. Bist du sicher das dieser Link existieren sollte? Überprüfe deine Rechtschreibung. Wende dich an einen Administrator, wenn du Zugriff auf diese Seite haben solltest.</p>
                        </Card.Body>
                        </>
                    }
                </Card>
                {
                    topic && topic.info ?
                    <Card tabIndex="0">
                        <Card.Header>Allgemeine Informationen</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <MarkdownDisplay content={topic?.info} />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    : null
                }
            </div>
        </>
    )
}



const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})